//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from '@/mixins/tooltip';
import DpCheckbox from '../checkbox/Checkbox.vue';

export default {
  name: 'DpCollapsableContent',
  components: {
    DpCheckbox,
  },
  mixins: [Tooltip],
  props: {
    title: { type: String, default: '' },
    selectable: { type: Boolean, default: false },
    value: { type: Boolean, default: false },
    showCheckbox: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  watch: {
    value(isOpen) {
      this.isOpen = isOpen;
    },
  },
  mounted() {
    this.isOpen = this.value;
  },
  methods: {
    open() {
      if (this.disabled) return;
      this.isOpen = true;
      this.updateModel();
    },
    close() {
      this.isOpen = false;
      this.updateModel();
    },
    toggle() {
      if (this.disabled) return;
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },
    updateModel() {
      this.$emit('input', this.isOpen);
      this.$emit('change', this.isOpen);
    },
  },
};
